exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-expand {\n  font-size: 0;\n}\n.table-expand label {\n  width: 100px;\n  color: #99a9bf;\n}\n.table-expand .el-form-item {\n  margin-right: 0;\n  margin-bottom: 0;\n}\n.gallery {\n  width: 80px;\n  margin-right: 10px;\n}\n.goods-detail-box img {\n  width: 100%;\n}\n", ""]);

// exports
